import { Alert, Box, CircularProgress, Dialog, DialogTitle } from '@mui/material';
import { extractErrorMessage } from '../../../utils/errorUtils';
import { useGetAiCredentialsQuery } from '../api/aiImplementationApi';
import { ConfigureAiProviderForm } from './ConfigureAiProviderForm';

type ConfigureAiProviderDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const ConfigureAiProviderDialog = ({ open, onClose }: ConfigureAiProviderDialogProps) => {
  const credentialsQuery = useGetAiCredentialsQuery(undefined, { skip: !open });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Set Up AI Provider</DialogTitle>
      {credentialsQuery.isLoading ? (
        <Box display="flex" justifyContent="center" py={5}>
          <CircularProgress />
        </Box>
      ) : credentialsQuery.isError ? (
        <Box p={3}>
          <Alert severity="error">
            {extractErrorMessage(credentialsQuery.error, 'Failed to load AI provider settings.')}
          </Alert>
        </Box>
      ) : (
        <ConfigureAiProviderForm
          credentials={credentialsQuery.data ?? []}
          onClose={onClose}
          refetchCredentials={credentialsQuery.refetch}
        />
      )}
    </Dialog>
  );
};
